import React, { FC } from 'react';

import { useTranslation } from 'app/lang';
import HiddenAccountNameItem from 'app/modules/Layout/Header/HiddenAccountNameItem/HiddenAccountNameItem';

import LinkMenuItem from '../../../DropdownMenu/LinkMenuItem';
import PromocodeLinkItem from '../../../DropdownMenu/PromocodeLinkItem';
import LogoutButtonItem from '../../../LogoutButtonItem/LogoutButtonItem';
import ThemeToggleItem from '../../../ThemeToggleItem';

import dictionary from './AuthorizedUserItems.dictionary.json';

import styles from './AuthorizedUserItems.module.scss';

type Props = {
  handleCloseMenu: () => void;
};

const AuthorizedUserItems: FC<Props> = ({ handleCloseMenu }) => {
  const { t } = useTranslation();

  return (
    <>
      <HiddenAccountNameItem onClick={handleCloseMenu} />

      <PromocodeLinkItem onClick={handleCloseMenu} />

      <LinkMenuItem to="/personal"
                    icon="private-office"
                    onClick={handleCloseMenu}
                    label={t(dictionary.linkPersonalProfileLabel)}
                    className={styles.linkMenuItem}
                    data-ga-event="header-cabinet"
                    data-ga-event-value="menuClick"
                    data-test="headerMenu-personalAccount" />

      <LinkMenuItem to="/personal/deposit"
                    icon="credit-card"
                    onClick={handleCloseMenu}
                    label={t(dictionary.linkDepositLabel)}
                    className={styles.linkMenuItem}
                    data-ga-event="depositStart"
                    data-ga-event-value="headerMenuClick"
                    data-test="headerMenu-fillBalance" />

      <LinkMenuItem to="/personal/profile"
                    icon="settings"
                    onClick={handleCloseMenu}
                    label={t(dictionary.linkProfileLabel)}
                    className={styles.linkMenuItem}
                    data-ga-event="profileSettings"
                    data-ga-event-value="headerMenuClick"
                    data-test="headerMenu-settings" />

      <ThemeToggleItem />

      <LogoutButtonItem onClick={handleCloseMenu} />
    </>
  );
};

export default AuthorizedUserItems;
